import React from "react";
import {
	Heading,
	Details,
	Title,
	Description,
	ProgramDetailsWrapper,
} from "./style";
import { useQuery } from "react-query";
import { formatDate } from "@website-builder/utilities-index";
import { getProgramInfo } from "@website-builder/services";
import { RichText } from "./../../../styles/richText";

const ProgramDetailsList = ({
	format,
	duration,
	shortName,
	programName,
	gridClass,
	titleBackgroundColor,
	titleOfCohortDate,
	cohortDate,
	cohortNextDate,
}) => {
	const {
		data: programInfo = [],
		error,
		isLoading,
	} = useQuery(
		["Program", programName],
		getProgramInfo(shortName, programName),
	);
	if (error) {
		console.error("Program Details List: Error while loading data", error);
	}
	const { content = {} } = programInfo;
	const { next_date_string = "", application_deadline = "" } = content;
	const cohortCutOffDate = formatDate(application_deadline, "MMM d, y");
	const formatPrimaryDesc = format.split(".")[0] || format;
	const formatSecondaryDesc = format.split(".")[1] || "";
	const durationPrimaryDesc = duration.split(".")[0] || duration;
	const durationSecondaryDesc = duration.split(".")[1] || "";
	return (
		<ProgramDetailsWrapper className="row">
			<Details className={gridClass}>
				<Title backgroundColor={titleBackgroundColor}>
					<span>Format:</span>
				</Title>
				<Description>
					<strong>{formatPrimaryDesc}</strong>
					<br />
					<span className="smallFont">{formatSecondaryDesc}</span>
				</Description>
			</Details>
			<Details className={gridClass}>
				<Title backgroundColor={titleBackgroundColor}>Duration:</Title>
				<Description>
					<strong>{durationPrimaryDesc}</strong>
					<br />
					<span className="smallFont">{durationSecondaryDesc}</span>
				</Description>
			</Details>
			<Details className={gridClass}>
				<Title backgroundColor={titleBackgroundColor}>
					{titleOfCohortDate ? titleOfCohortDate : "Apply by:"}
				</Title>
				<Description>
					<strong>{cohortDate ? cohortDate : cohortCutOffDate}</strong>
					<br />
					<span className="smallFont">
						{cohortNextDate
							? cohortNextDate
							: `Cohort starts ${next_date_string}`}
					</span>
				</Description>
			</Details>
		</ProgramDetailsWrapper>
	);
};

export default ProgramDetailsList;
